import { createContext } from 'react';

/**
 * How the home page's labeled buttons open the shell's side panels: the links drawer
 * (ADR 0044) and the side navigation (ADR 0045). On home, Cloudscape's icon-only
 * toggles are left out while a panel is closed, so the shell hands these down instead.
 * It is null outside the shell, where the buttons render nothing.
 */
export interface PanelControl {
  open: boolean;
  toggle: () => void;
}

export interface HeroPanels {
  links: PanelControl;
  menu: PanelControl;
}

export const HeroPanelsContext = createContext<HeroPanels | null>(null);

/** The side navigation's labels. Without them Cloudscape's toggle and close buttons have no name. */
export const MENU_COPY = {
  region: 'Menu',
  homeButton: 'Menu',
  toggle: 'Open menu',
  close: 'Close menu',
} as const;
